import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    modalContext: 'Notifications',
    timezone: 'UTC',
    exporting: false,
    exportComplete: false,
    notifications: [],
    modalActive: false,
    studentCount: 0,
    dbOperations: 0,
    currentStudent: null,
    globalTrans: false,
    downloadURL: '',
    user: null,
    firstName: null,
    lastName: null,
    dark: false,
    modulePage: false,
    moduleClick: false,
    lessonPage: false,
    navTrigger: false,
    dashMod: '',
    finished: false,
    timeSpent: {
      total: 0,
      dashboard: 0,
      advisoryLessons: 0,
      msLessons: 0,
      operationsLessons: 0,
      advisoryQuizzes: 0,
      msQuizzes: 0,
      operationsQuizzes: 0
    }
  },
  mutations: {
    updateModal: (state, context) => { state.modalContext = context },
    updateTimezone: (state, timezone) => { state.timezone = timezone },
    exportURL: (state, downloadURL) => { state.downloadURL = downloadURL },
    exportComplete: (state) => { state.exportComplete = true },
    isExporting: state => { state.exporting = true },
    isNotExporting: state => { state.exporting = false },
    pushNotification: (state, notificationContext) => { state.notifications.push(notificationContext) },
    removeNotification: ( state, notificationIndex ) => { state.notifications.splice(notificationIndex, 1) },
    openModal: (state, context) => { state.modalActive = true; state.modalContext = context },
    closeModal: (state) => { state.modalActive = false; },
    studentCount: (state, total) => { state.studentCount = total },
    logOperation: (state, message) => { state.dbOperations++; console.log(state.dbOperations, message); },
    setCurrentStudent: (state, context) => { state.currentStudent = context },
    exporting: state => { state.exporting = true },
    unfinish: state => { state.finished = false },
    finish: state => { state.finished = true; },
    updateName: (state, firstName, lastName) => { state.firstName = firstName; state.lastName = lastName; },
    updateUser: (state, user) => { state.user = user },
    toggleDark: state => state.dark = !state.dark,
    modulePage: state => {
      state.modulePage = true; 
      state.moduleClick = false; 
      state.dashMod = '';
      console.log('module clicked?: ' + state.moduleClick);
      console.log('nav clicked?: ' + state.modulePage);
    },
    lessonPage: state => {
      state.lessonPage = true;
      state.dashMod = '';
    },
    moduleClick: state => {
      state.moduleClick = true; 
      state.modulePage = false;
    },
    navTrigger: state => {
      state.navTrigger = !state.navTrigger;
      state.dashmod = '';
    },
    dashMod: (state, context) => {
      state.dashMod = context;
    },
    tock: (state, context) => {
      if(context == 'dashboard') {
        state.timeSpent.dashboard++;
      }
      else if(context == 'advisoryLessons') {
        state.timeSpent.advisoryLessons++;
      }
      else if(context == 'advisoryLessons') {
        state.timeSpent.advisoryLessons++;
      }
      else if(context == 'msLessons') {
        state.timeSpent.msLessons++;
      }
      else if(context == 'operationsLessons') {
        state.timeSpent.operationsLessons++;
      }
      else if(context == 'advisoryQuizzes') {
        state.timeSpent.advisoryQuizzes++;
      }
      else if(context == 'msQuizzes') {
        state.timeSpent.msQuizzes++;
      }
      else /* operations quizzes */ {
        state.timeSpent.operationsQuizzes++;
      }
    }
  },
  actions: {
  },
  modules: {
  }
})
